import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from '../ui/drawer';
import { Sidebar } from './Sidebar';

/**
 * MoreMenuDrawer - Bottom sheet opened from the "Mehr" tab
 * of the MobileTabBar. Renders the full Sidebar (with teams,
 * tools, AI workspace, settings) inside a slide-up drawer.
 */
export function MoreMenuDrawer({ open, onOpenChange }) {
  const handleClose = () => onOpenChange(false);

  return (
    <Drawer open={open} onOpenChange={onOpenChange} shouldScaleBackground={false}>
      <DrawerContent
        className="h-[90vh] p-0 overflow-hidden bg-transparent border-0"
        data-testid="mobile-more-drawer"
      >
        <DrawerHeader className="sr-only">
          <DrawerTitle>Weitere Menüpunkte</DrawerTitle>
        </DrawerHeader>
        <div className="flex-1 overflow-hidden">
          <Sidebar fullWidth onNavigate={handleClose} />
        </div>
      </DrawerContent>
    </Drawer>
  );
}
